import React from "react";
import { Modal, Button } from "react-bootstrap";
import { IoCloseSharp } from "react-icons/io5";

interface GlobalModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subtitle?: string;
  confirmText?: string;
}

const GlobalModal: React.FC<GlobalModalProps> = ({
  show,
  onClose,
  onConfirm,
  title,
  subtitle,
  confirmText,
  children,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      {/* Header */}
      <Modal.Header className="border-0">
        <div className="d-flex align-items-center gap-3 w-100">
          <Button
            variant="light"
            onClick={onClose}
            style={{
              border: "none",
              boxShadow: "none",
              padding: 0,
              backgroundColor: "white",
            }}
          >
            <IoCloseSharp size={22} style={{ backgroundColor: "white" }} />
          </Button>
          <Modal.Title className="fw-semibold m-0">{title}</Modal.Title>
        </div>
      </Modal.Header>

      {/* Body */}
      <Modal.Body style={{ paddingTop: "0.5%" }}>
        {/* Subtitle (conditionally rendered) */}
        {subtitle && (
          <p style={{ fontSize: "20px", fontWeight: 500, lineHeight: "24px" }}>
            {subtitle}
          </p>
        )}
        <div>{children}</div>
      </Modal.Body>
    </Modal>
  );
};

export default GlobalModal;
